import React, { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import "./App.css";
import FooterContainer from "./Components/Footer/FooterContainer";
import HeaderContainer from "./Components/Header/HeaderContainer";
import LoaderContainer from "./Components/common/Loader/LoaderContainer";
import { publicRoutes, RoutesNames } from "./common/routes";
import { useSelector } from "react-redux";
import Loader from "./Components/common/Loader/Loader";
import { GlobalDebug } from "./remove-console";

const SidebarContainer = React.lazy(() =>
  import("./Components/SidebarPage/SidebarContainer")
);
const NoNet = React.lazy(() => import("./Components/common/NoNet/NoNet"));
const CheckOrderContainer = React.lazy(() =>
  import("./Components/modal/checkOrder/CheckOrderContainer")
);

const App = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasApplicant = useSelector(
    (state) => state?.applicantPage?.hasApplicant
  );

  useEffect(() => {
    (process.env.NODE_ENV === "production" ||
      process.env.REACT_APP_ENV === "STAGING") &&
      GlobalDebug?.(false);
  }, []);

  // чтобы не триггерить редирект на ту же страницу лишний раз
  useEffect(() => {
    if (hasApplicant && location?.pathname !== RoutesNames?.APPLICANT) {
      navigate?.(RoutesNames?.APPLICANT, { replace: true });
    }
  }, [hasApplicant, navigate, location?.pathname]);

  return (
    <div className="App">
      <React.Suspense fallback={<Loader />}>
        <LoaderContainer />
        <HeaderContainer />
        <CheckOrderContainer />
        {/* <SpeedDialComponent actions={props?.speedDialItems}/> */}
        <NoNet />
        <SidebarContainer />

        <Routes>
          {publicRoutes?.map?.((route) => {
            const Cmp = route?.component;
            return (
              <Route key={route?.path} path={route?.path} element={<Cmp />} />
            );
          })}
          <Route
            path="*"
            element={<Navigate to={RoutesNames?.CARDS} replace />}
          />
        </Routes>

        <FooterContainer />
      </React.Suspense>
    </div>
  );
};

export default App;
